import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import {keyboardKeys} from '../../constants/keyboard-keys.constants';
import {ValidationService} from '../../services/validation.service';

@Component({
  selector: 'si-check',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckComponent {
  @Input() text: string;
  @Input() styleClass: string;
  @Input() id: string;
  @Input() name: string;
  @Input() model: any;
  @Output() modelChange = new EventEmitter<any>();
  @Input() disabled: boolean;
  @Input() rule: string;
  @Input() validationExternalErrorText: string;
  @Input() tooltipPosition: string;
  @Input() tooltipText: string;
  @Input() tooltipIcon: string;
  @ContentChild('preCheckContent') preCheckContent: TemplateRef<ElementRef>;
  showRuleErrorOutsideIcon: boolean;
  validationErrorText: string;
  private _checked;

  constructor(
    private validationService: ValidationService
  ) {
    this.setLogic();
  }

  get checked() {
    return this._checked;
  }

  @Input()
  set checked(val) {
    if (this.model != null) {
      return;
    }

    if (val || val === '') {
      this.model = true;
    } else {
      this.model = false;
    }

    this.onChangeModel(this.model);
  }

  setLogic(): void {
    this.showRuleErrorOutsideIcon = this.validationService.getShowRuleErrorOutsideIcon();
  }

  onChangeModel(model) {
    setTimeout(() => {
      this.modelChange.emit(model);
    });
  }

  @HostListener('keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === keyboardKeys.ENTER) {
      this.model = !this.model;
      this.onChangeModel(this.model);
    }
  }
}
